"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Storage_1 = __importDefault(require("../utils/Storage"));
var storages_1 = require("../data/storages");
var AppService = /** @class */ (function () {
    function AppService() {
        var Storage = new Storage_1.default();
        AppService.storage = Storage.getStorage();
    }
    AppService.setValue = function (key, value) {
        var storeValue = AppService.getValue(key);
        if (storeValue === value)
            return;
        var store = AppService.storage.getItem(storages_1.APP_STORAGE);
        var keyValStore = store !== null ? JSON.parse(store) : {};
        keyValStore[key] = value;
        AppService.storage.setItem(storages_1.APP_STORAGE, JSON.stringify(keyValStore));
    };
    AppService.hasKey = function (key) {
        var store = AppService.storage.getItem(storages_1.APP_STORAGE);
        if (store === null)
            return false;
        var keyValStore = JSON.parse(store);
        return keyValStore[key] !== undefined ? keyValStore[key] : false;
    };
    AppService.getValue = function (key) {
        var value = AppService.hasKey(key);
        return value !== false ? value.toString() : null;
    };
    AppService.removeValue = function (key) {
        var value = AppService.hasKey(key);
        if (value === false)
            return;
        var store = JSON.parse(AppService.storage.getItem(storages_1.APP_STORAGE));
        store[key] = undefined;
        AppService.storage.setItem(storages_1.APP_STORAGE, JSON.stringify(store));
    };
    return AppService;
}());
exports.default = AppService;
